import React, { Component } from "react";
import { FiCast, FiLayers, FiUsers, FiMonitor } from "react-icons/fi";

const ServiceList = [
  {
    icon: <FiCast />,
    title: "Tüm elektrik işleriniz için",
    description:
      "Ev ve iş yerlerinizde ihtiyaç duyulan tüm elektrik işlerini düzenli, güvenli ve sorunsuz şekilde yapıyoruz.",
  },
  {
    icon: <FiLayers />,
    title: "Elektrik çözümleri",
    description:
      "Arıza, yenileme veya yeni tesisat fark etmeksizin ihtiyacınıza uygun elektrik çözümleri sunuyoruz.",
  },
  {
    icon: <FiUsers />,
    title: "Keşif ve değerlendirme",
    description:
      "İşe başlamadan önce durumu inceler, yapılması gerekenleri açık ve net şekilde paylaşırız.",
  },
  {
    icon: <FiMonitor />,
    title: "Yenilenebilir enerji çözümleri",
    description:
      "Güneş enerjisi ve benzeri sistemler için temel kurulum ve bağlantı işlemlerinde destek sağlıyoruz.",
  },
  {
    icon: <FiUsers />,
    title: "Ev tipi güneş enerjisi",
    description:
      "Evler için uygun güneş enerjisi sistemlerinin kurulumu ve bağlantı işlemlerini güvenle yapıyoruz.",
  },
  {
    icon: <FiMonitor />,
    title: "Pano çözümleri",
    description:
      "Elektrik panosu, sigorta ve sistem düzenlemelerini daha güvenli ve anlaşılır hale getiriyoruz.",
  },
];

class ServiceThree extends Component {
  render() {
    const { column } = this.props;
    const ServiceContent = ServiceList.slice(0, this.props.item);

    return (
      <React.Fragment>
        <div className="row">
          {ServiceContent.map((val, i) => (
            <div className={`${column}`} key={i}>
              <a>
                <div className="service service__style--2">
                  <div className="icon">{val.icon}</div>
                  <div className="content">
                    <h3 className="title">{val.title}</h3>
                    <p>{val.description}</p>
                  </div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </React.Fragment>
    );
  }
}
export default ServiceThree;
